import { useMutation } from "react-query";
import { createApiWithPath } from "../../client";
import { VoiceRequestStatus } from "../../types/voice-requests";

interface UpdateVoiceRequestStatusPayload {
  id: string;
  status: VoiceRequestStatus;
}

export const useUpdateVoiceRequestStatus = () => {
  return useMutation(async (payload: UpdateVoiceRequestStatusPayload) => {
    const response = await createApiWithPath("voice-requests").patch(
      `/${payload.id}`,
      {
        status: payload.status,
      },
    );
    return response.data;
  });
};
